import { useQuery } from '@tanstack/react-query';
import { estimateResourcesService } from '../services/estimateResources.service';

export function useEstimateResources(estimateId?: string) {
  const query = useQuery({
    queryKey: ['estimates', 'resources', estimateId],
    queryFn: () => estimateResourcesService.getByEstimateId(estimateId!),
    enabled: !!estimateId,
  });

  return {
    resources: query.data || [],
    isLoading: query.isLoading,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
